function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, CSSProperties, Ref, RefObject, ElementType } from 'react';
import cn from 'classnames';
require("./Preloader.css");
var styles = {
  "Root": "Preloader-module-Root_KaK",
  "centerPosition": "Preloader-module-centerPosition_2Cy",
  "sSize": "Preloader-module-sSize_17a",
  "mSize": "Preloader-module-mSize_ATx",
  "lSize": "Preloader-module-lSize_3UG"
};
export const PreloaderPositions = {
  center: 'center'
};
export const PreloaderSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const Preloader = ({
  className,
  innerRef,
  controlRef,
  style = {},
  size = PreloaderSizes.m,
  position,
  tag = 'div',
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, styles[`${position}Position`], styles[`${size}Size`], className),
    ref: innerRef || controlRef
  }, props));
};
if (process.env.NODE_ENV !== 'production') {
  Preloader.displayName = 'Preloader';
}